import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MegaphoneIcon, PenToolIcon, UsersIcon, CodeIcon, ArrowRightIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Marketing',
    description: 'Data-driven SEO, PPC, and social media campaigns designed to drive qualified traffic and maximize your ROI.',
    icon: MegaphoneIcon,
    color: 'bg-red-100 text-red-600'
  }, {
    title: 'Design',
    description: 'High-converting landing pages, brand identity, and creative assets that capture attention and build trust.',
    icon: PenToolIcon,
    color: 'bg-blue-100 text-blue-600'
  }, {
    title: 'CRM',
    description: 'Automated lead nurturing, pipeline management, and customer retention strategies to close more deals.',
    icon: UsersIcon,
    color: 'bg-green-100 text-green-600'
  }, {
    title: 'Dev',
    description: 'Custom web development, fast-loading sites, and technical integrations that power your marketing engine.',
    icon: CodeIcon,
    color: 'bg-purple-100 text-purple-600'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="services" className="py-24 bg-white" data-id="element-282" data-mp="3tzxyw8eqtg85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283" data-mp="3g17ue7plge9r">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-284" data-mp="3l13x83mk1znq">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight" data-id="element-285" data-mp="3kzj3uhbz8mrg">
            Everything you need to scale
          </h2>
          <p className="text-lg text-gray-600" data-id="element-286" data-mp="29mqgdiq7ykh7">
            We provide an end-to-end growth ecosystem. From driving traffic to
            closing leads, we've got you covered.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-287" data-mp="1li8zn9wh5vxx">
          {services.map((service, index) => <motion.div key={index} variants={cardVariants} className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group flex flex-col h-full" data-id="element-288" data-mp="16uwalb7gl82s" data-mpi={index}>
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 ${service.color}`} data-id="element-289" data-mp="sv4yjg0i61rf">
                <service.icon className="w-7 h-7" data-id="element-290" data-mp="2s4l7chqxw0in" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-291" data-mp="2n8mf2j2hpycy">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 flex-1" data-id="element-292" data-mp="2upj9m80jc2t6">{service.description}</p>
              <a href={`#${service.title.toLowerCase()}`} className="inline-flex items-center text-sm font-semibold text-gray-900 group-hover:text-red-600 transition-colors mt-auto" data-id="element-293" data-mp="2zom4x0qpquny">
                Learn More
                <ArrowRightIcon className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-294" data-mp="2btb0uu8bd9t4" />
              </a>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}